
import { chatwindowDetails } from "../../models/model";
import { ChatWindowActions } from "../interface/reducerType";

import { Types } from '../action/action';

const initialState = {

  isChatWindow: false,
  chatWindowDetails: {},
  isMySpace: false,
  editDraft: '',
  isNewMessageWindow: false,
  newUserMessage: {},
  openNewMessage: false,
  newUserMembers: [],
  isMultiNewUserchat: false,
  multiMemberList:[],
  windowResize:0,
  clearChatMsg:'',
  newTagMessage:[],
  fileOpenMessage:false

};

export const chatWindowReducer = (state: chatwindowDetails = initialState, action: ChatWindowActions) => {
  switch (action.type) {

    case Types.OPEN_CHAT_WINDOW:
      return {
        ...state, isChatWindow: action.payload.isChatWindow,
        chatWindowDetails: action.payload.chatWindowDetails,
        isMySpace: action.payload.isMySpace,
        openNewMessage: action.payload.openNewMessage,
        isNewMessageWindow: action.payload.isNewMessageWindow,
        newUserMembers: action.payload.newUserMembers,
        multiMemberList:action.payload.multiMemberList
      };
    case Types.SET_CONTACT_WINDOW:
      return {
        ...state,
        chatWindowDetails: action.payload.chatWindowDetails
      };

    case Types.UPDATE_TEAM_MEMBER:
      return {
        ...state,
        newUserMembers: action.payload.newUserMembers
      }
    case Types.OPEN_NEW_MESSAGE:
      return {
        ...state, isNewMessageWindow: action.payload.isNewMessageWindow,
        newUserMessage: action.payload.newUserMessage, newUserDetails: action.payload.newUserDetails, isChatWindow: false
      };
    case Types.EDIT_DRAFT:
      return {
        ...state, editDraft: action.payload.editDraft
      };
    case Types.MULTI_NEWMESSAE:
      return {
        ...state, isMultiNewUserchat: action.payload.isMultiNewUserchat,
        multiMemberList:action.payload.multiMemberList

      };
    case Types.EMPTY_CHATWINDOWDETAILS:
      return {
        ...state, chatWindowDetails: {},
        isChatWindow: false
      };
      case Types.CHAT_WINDOW_RESIZE:
        return {
          ...state, windowResize: action.payload.windowResize
        };
        case Types.CHAT_CLEAR_MESSAGE:
          return {
            ...state, clearChatMsg: action.payload.clearChatMsg
          };
          case Types.NEW_TAG_MESSAGE:
            return {
              ...state, newTagMessage: action.payload.newTagMessage
            };
            case Types.FILE_OPEN_STATE:
              return {
                ...state, fileOpenMessage: action.payload.fileOpenMessage
              };
    default:
      return state;
  }
};